import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcActionsPopover from '@/views/Automation/CampaignCreatorV2/components/CcPopover/CcActionsPopover.ts.vue';
import {
  FilterImageEvent,
  ViewLevelActionsEvent,
} from '@/views/Automation/CampaignCreatorV2/components/CcPopover/helpers';
import { ViewLevelAction } from '@/views/Automation/CampaignCreatorV2/types';
import { Position } from '@sh/types';
import { computed } from 'vue';

interface Props {
  secondaryCategories: ViewLevelAction<FilterImageEvent>[][];
}

interface Emits {
  (e: 'event', value: ViewLevelActionsEvent): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcSecondaryFilter.ts',
  props: {
    secondaryCategories: null
  },
  emits: ["event"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'event', value: ViewLevelActionsEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  secondaryCategories: ViewLevelAction<FilterImageEvent>[][];
};





const activeSpecificFilters = computed(() =>
  props.secondaryCategories.flat().reduce((active: FilterImageEvent[], filter) => {
    if (filter.active) {
      active.push(filter.event);
    }
    return active;
  }, [])
);

return { __sfc: true,props, emits, activeSpecificFilters, CcIcon, CcActionsPopover, Position }
}

})